import { useEffect } from 'react';

export function useJsonLd(data) {
  useEffect(() => {
    if (!data) return;
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'json-ld-structured-data';
    script.text = JSON.stringify(data);

    const existing = document.getElementById('json-ld-structured-data');
    if (existing) existing.remove();
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById('json-ld-structured-data');
      if (el) el.remove();
    };
  }, [data]);
}
